<template>
    <div class="contenido">
        <Titulo titulo="PERFIL"/>

        <b-container>
            <b-row>
                <b-col offset="2" cols="8">
                    <b-tabs content-class="mt-3">
                        <b-tab title="Perfil de usuario" active>
                            <b-row>
                                <b-col cols="12" md="4" class="text-center">
                                    <img src="../assets/usuario.jpg" alt="">
                                </b-col>
                                <b-col cols="12" md="8">
                                    <!-- nombre -->
                                    <b-row class="mb-1">
                                        <b-col cols="12" lg="2">
                                            Nombre:
                                        </b-col>
                                        <b-col cols="12" lg="10">
                                            <b-form-input :value="usuario.nombre" placeholder="Nombre completo..." disabled></b-form-input>
                                        </b-col>
                                    </b-row>
                                    <!-- usuario -->
                                    <b-row class="mb-1">
                                        <b-col cols="12" lg="2">
                                            Usuario:
                                        </b-col>
                                        <b-col cols="12" lg="10">
                                            <b-form-input :value="usuario.usuario" placeholder="Usuario" disabled></b-form-input>
                                        </b-col>
                                    </b-row>
                                    <!-- telefono -->
                                    <b-row class="mb-1">
                                        <b-col cols="12" lg="2">
                                            Teléfono:
                                        </b-col>
                                        <b-col cols="12" lg="10">
                                            <b-form-input :value="usuario.telefono" placeholder="" disabled></b-form-input>
                                        </b-col>
                                    </b-row>
                                    <!-- telefono -->
                                    <b-row class="mb-1">
                                        <b-col cols="12" lg="2">
                                            Celular:
                                        </b-col>
                                        <b-col cols="12" lg="10">
                                            <b-form-input :value="usuario.celular" placeholder="" disabled></b-form-input>
                                        </b-col>
                                    </b-row>
                                    <!-- telefono -->
                                    <b-row class="mb-5">
                                        <b-col cols="12" lg="2">
                                            E-mail:
                                        </b-col>
                                        <b-col cols="12" lg="10">
                                            <b-form-input :value="usuario.email" placeholder="" disabled></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Actualizar contraseña">
                            <b-row>
                                <b-col cols="12" md="4" class="text-right">
                                    <img src="../assets/usuario.jpg" alt="">
                                </b-col>
                                <b-col cols="12" md="8">
                                    <b-form @submit.prevent="cambiarContrasena" id="formUpdContrasenia" autocomplete="off">
                                        <!-- contraseña 1 -->
                                        <b-row class="mb-1">
                                            <b-col cols="5">
                                                Contraseña:
                                            </b-col>
                                            <b-col cols="7">
                                                <b-form-input type="password" name="password" v-model="password1" placeholder=""></b-form-input>
                                            </b-col>
                                        </b-row>
                                        <!-- contraseña 2 -->
                                        <b-row class="mb-1">
                                            <b-col cols="5">
                                                Repetir contraseña:
                                            </b-col>
                                            <b-col cols="7">
                                                <b-form-input type="password" v-model="password2" placeholder=""></b-form-input>
                                            </b-col>
                                        </b-row>

                                        <!-- mensaje -->
                                        <b-row>
                                            <b-col cols="12">
                                                <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>{{ mensajeError }}</b-alert>
                                            </b-col>
                                        </b-row>

                                        <b-row class="mb-5">
                                            <b-button type="submit" variant="outline-primary"><b-icon-check-circle></b-icon-check-circle> Actualizar</b-button>
                                        </b-row>
                                    </b-form>
                                    
                                </b-col>
                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-col>

            </b-row>
        </b-container>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import Titulo from '@/components/Titulo.vue'
import axios from 'axios'
import {mapState} from 'vuex'

export default {
    name: 'Perfil',
    props: {
    },
    components: {
        Titulo
    },
    data() {
        return {
            usuario: {},
            password1: '',
            password2: '',
            mensajeError: '',
            showDismissibleAlert: false
        }
    },
    created() {
        if (localStorage.getItem('idUsuario')) {
            this.traerUsuario()
        }

        if (this.token == '') {
            this.$router.push('nosesion')
        }
    },
    methods: {
        traerUsuario() {
            var formData = new FormData();
            formData.append("accion", "mostrarDatos");
            formData.append("tabla", "usuarios");
            formData.append("filtro", `id_usuario=${this.idUsuario}`);
            formData.append("limite", 1);
            
            axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
            .then((res) => {
                this.usuario = res.data
            });
        },
        cambiarContrasena() {
            if (this.password1 == '' || this.password2 == '') {
                Swal.fire({
                    title: 'Atención',
                    text: 'Debes capturar ambas contraseñas',
                    icon: 'warning',
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: '#3085d6',
                })

                return
            }

            if (this.password1 != this.password2) {
                this.showDismissibleAlert = true
                this.mensajeError = 'Las contraseñas no coinciden... '

                return
            }

            const form = document.getElementById('formUpdContrasenia')
            var formData = new FormData(form);
            formData.append("accion", "actualizarContrasenia");
            formData.append("idUsuario", this.idUsuario);
            
            axios.post(`${this.url}/ajax/ajax.usuarios.php`, formData)
            .then(res => {
                if (res.data == 'ok') {
                    this.$toasted.success("Actualizado!", { duration : 2000 });
            
                    form.reset();
                } else {
                    Swal.fire({
                        title: 'Atención',
                        text: 'Ocurrió un error al actualizar la contraseña',
                        icon: 'warning',
                        confirmButtonText: 'Aceptar',
                        confirmButtonColor: '#3085d6',
                    })
                }
            });

            
        }
    },
    computed: {
        url() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return this.urlSandbox
            } else {
                return this.urlProd
            }
        },
        ...mapState(['urlProd', 'urlSandbox', 'token', 'idUsuario'])
    }
}
</script>

<style scoped>
.contenido{
    min-height: 500px;
}
</style>